/*
Muestra un encabezado indicando cuando la sucursal fue desactivada
*/

import { BranchState } from '../enums/DocStates'
import { fechaIsoToYYYY_MM_DD, formatDate } from '../utils/utils'

const BranchStatusHeader: React.FC<{
  name: string
  state: BranchState
  date: string
}> = ({ name, state, date }) => {
  if (state === BranchState.Activo) {
    return null // No mostramos nada si está activo
  }

  if (state !== BranchState.Inactivo) {
    return null
  }

  // Configurar el mensaje solo para "Desactivado"
  const action = 'fue desactivada'
  const article = 'Esta'
  const formatedDate = formatDate(fechaIsoToYYYY_MM_DD(date))

  return (
    <div className="w-full border-8 border-orange-200 border-l-orange-600 pl-1 mb-2">
      <div>{`${article} ${name} ${action} el ${formatedDate}.`}</div>
    </div>
  )
}

export default BranchStatusHeader
